// extracted by mini-css-extract-plugin
module.exports = {"main":"Divider_main__bPfiD","textNoHR":"Divider_textNoHR__2Zgbo","text":"Divider_text__20CvV","fa":"Divider_fa__23KPV","hr":"Divider_hr__98RAJ"};